/* ==========================================================================
   HSY Header: mega menu hover/keyboard/touch, sticky state, mobile drawer,
   cart count refresh. No dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var instances = new WeakMap();
  var cartPatched = false;

  function hoverCapable() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }
  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  /* ---------- cart count ---------- */
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-hsy-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () {});
  }

  function patchCart() {
    if (cartPatched) return;
    cartPatched = true;

    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(function (name) {
      document.addEventListener(name, refreshCart);
    });

    // Refresh after any Ajax cart call the theme makes. The response is passed through untouched.
    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function') return;
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(url)) {
          p.then(function (res) { if (res && res.ok) refreshCart(); }).catch(function () {});
        }
      } catch (e) { /* ignore */ }
      return p;
    };
  }

  /* ---------- per-section init ---------- */
  function init(root) {
    if (instances.has(root)) return;

    var ac = new AbortController();
    var opts = { signal: ac.signal };
    instances.set(root, ac);

    var wrapper = root.parentElement;
    var header = root.querySelector('[data-hsy-header]');
    var scrim = root.querySelector('[data-hsy-scrim]');
    var drawer = root.querySelector('[data-hsy-drawer]');
    var burger = root.querySelector('[data-hsy-burger]');
    var closeBtn = root.querySelector('[data-hsy-drawer-close]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.hsy-nav__item.has-mega'));
    var overlay = root.getAttribute('data-overlay') === 'true';
    var sticky = root.getAttribute('data-sticky') === 'true';

    var openItem = null;
    var openTimer, closeTimer;

    /* --- media inside mega panels: only run when visible --- */
    function setMedia(item, on) {
      item.querySelectorAll('.hsy-card__video').forEach(function (v) {
        v.muted = true;
        v.playsInline = true;
        if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
      item.querySelectorAll('iframe[data-hsy-src]').forEach(function (f) {
        if (on) {
          if (!f.getAttribute('src')) f.setAttribute('src', f.getAttribute('data-hsy-src'));
        } else {
          f.removeAttribute('src'); // stops playback, frees bandwidth
        }
      });
    }

    function sync() {
      var on = !!openItem;
      header.classList.toggle('is-open', on);
      scrim.classList.toggle('is-on', on || drawerOpen());
    }

    function openMega(item) {
      if (openItem === item) return;
      closeMega(true);
      openItem = item;
      item.classList.add('is-open');
      var trigger = item.querySelector('.hsy-nav__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      setMedia(item, true);
      sync();
    }

    function closeMega(silent) {
      if (!openItem) return;
      var item = openItem;
      openItem = null;
      item.classList.remove('is-open');
      var trigger = item.querySelector('.hsy-nav__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      setMedia(item, false);
      if (!silent) sync();
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.hsy-nav__link');

      item.addEventListener('mouseenter', function () {
        if (!hoverCapable() || !isDesktop()) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { openMega(item); }, openItem ? 0 : 80);
      }, opts);

      item.addEventListener('mouseleave', function () {
        if (!hoverCapable()) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { if (openItem === item) closeMega(); }, 140);
      }, opts);

      // touch / no-hover: first tap opens, second tap follows the link
      trigger.addEventListener('click', function (e) {
        if (!isDesktop()) return;
        var noLink = !trigger.hasAttribute('href');
        if (!hoverCapable() || noLink) {
          if (openItem !== item) { e.preventDefault(); openMega(item); }
          else if (noLink) { e.preventDefault(); closeMega(); }
        }
      }, opts);

      trigger.addEventListener('keydown', function (e) {
        if (!isDesktop()) return;
        var noLink = !trigger.hasAttribute('href');
        if (e.key === 'ArrowDown' || (noLink && (e.key === 'Enter' || e.key === ' '))) {
          e.preventDefault();
          openMega(item);
          var first = item.querySelector('.hsy-mega a');
          if (first) first.focus();
        }
      }, opts);

      // close when keyboard focus leaves the item
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget) && openItem === item && !item.matches(':hover')) closeMega();
      }, opts);
    });

    scrim.addEventListener('click', function () { closeMega(); closeDrawer(); }, opts);

    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) closeMega();
    }, opts);

    /* --- mobile drawer --- */
    var lastFocus = null;
    function drawerOpen() { return drawer && drawer.classList.contains('is-open'); }

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.removeAttribute('inert');
      drawer.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('hsy-lock');
      scrim.classList.add('is-on');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      if (!drawer || !drawerOpen()) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      burger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('hsy-lock');
      sync();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (burger) burger.addEventListener('click', openDrawer, opts);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer, opts);

    drawer && drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('a[href], button, summary');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }, opts);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (openItem) {
        var t = openItem.querySelector('.hsy-nav__link');
        closeMega();
        if (t) t.focus();
      }
      closeDrawer();
    }, opts);

    window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) {
      if (e.matches) closeDrawer(); else closeMega();
    }, opts);

    /* --- sticky / scrolled state --- */
    // Solid header: when stuck it becomes position:fixed, so the section wrapper keeps the
    // header's natural height as a placeholder. Without it the page would jump when the
    // header shrinks.
    function measure() {
      if (overlay || !sticky) return;
      var was = header.classList.contains('is-stuck');
      header.classList.add('is-measuring');
      header.classList.remove('is-stuck');
      wrapper.style.minHeight = header.getBoundingClientRect().height + 'px';
      if (was) header.classList.add('is-stuck');
      void header.offsetHeight; // flush before transitions come back
      header.classList.remove('is-measuring');
    }

    function onScroll() {
      if (!sticky) { header.classList.remove('is-stuck'); return; }
      header.classList.toggle('is-stuck', wrapper.getBoundingClientRect().top < 0);
    }

    function onResize() { measure(); onScroll(); }

    window.addEventListener('scroll', onScroll, { passive: true, signal: ac.signal });
    window.addEventListener('resize', onResize, { passive: true, signal: ac.signal });
    window.addEventListener('load', onResize, { signal: ac.signal });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
    root.querySelectorAll('.hsy-logo__img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', onResize, { signal: ac.signal });
    });
    onResize();
  }

  function initAll() {
    document.querySelectorAll('[data-hsy-root]').forEach(init);
  }

  function destroy(root) {
    var ac = instances.get(root);
    if (ac) { ac.abort(); instances.delete(root); }
    document.documentElement.classList.remove('hsy-lock');
  }

  window.HSYHeader = { refreshCart: refreshCart };

  patchCart();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Theme editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hsy-root]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-hsy-root]').forEach(destroy);
  });
  // Keep a block's mega panel open while it is selected in the editor
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('.hsy-nav__item.has-mega');
    if (item && hoverCapable()) item.dispatchEvent(new MouseEvent('mouseenter'));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var item = e.target.closest && e.target.closest('.hsy-nav__item.has-mega');
    if (item) item.dispatchEvent(new MouseEvent('mouseleave'));
  });
})();
